import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { EMPTY } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  constructor(
    private afMessaging: AngularFireMessaging,
    private httpService: HttpService
  ) { }

  requestPermission() {
    this.afMessaging.requestToken
      .pipe(
        switchMap((token) => {
          console.log('deviceToken::', token);
          return this.httpService.post('/student/device', { deviceToken: token });
        }),
        catchError((error) => {
          console.error(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  deleteToken() {
    this.afMessaging.getToken
      .pipe(mergeMap((token) => {
        if (!token) {
          return EMPTY;
        }
        return this.afMessaging.deleteToken(token);
      }))
      .subscribe();
  }
}
